import { customizations } from "@naf/teamscheme";
import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import LoadingBox from "../shared/LoadingBox";
import { GlobalStyle } from "../renderer/GlobalStyle";
import { AppWrapper } from "./AppWrapper";
import { AppLayout } from "../shared/layout/AppLayout";
import StandaloneHeader from "../shared/layout/header/StandaloneHeader";
import { CopyFooter } from "../shared/elements/CopyFooter";
import { ThemedErrorBoundary } from "../ThemedErrorBoundary";
import { Main } from "../Main";

export function LoadingRouteScreen() {
  return (
    <AppLayout>
      <Main>
        <StandaloneHeader />
        <LoadingBox />
      </Main>
    </AppLayout>
  );
}

export function PageShell() {
  return (
    <ThemeProvider
      theme={{
        ...customizations,
        focus: { ...customizations.focus, color: "black" },
      }}
    >
      <GlobalStyle />
      <ThemedErrorBoundary>
        <Suspense fallback={<LoadingRouteScreen />}>
          <AppWrapper>
            <Outlet />
            <CopyFooter />
            <ScrollRestoration />
          </AppWrapper>
        </Suspense>
      </ThemedErrorBoundary>
    </ThemeProvider>
  );
}
